// extracted by mini-css-extract-plugin
export default {"loaderSection":"loader_loaderSection__dwo0Q","loaderSecitionh1":"loader_loaderSecitionh1__DFn8t","lds_ring":"loader_lds_ring__j2lnM"};